import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import TextInput from "../../../../components/inputs/text";
import SelectInput from "../../../../components/inputs/select";
import Loading from "../../../../components/loading";
import AlertMessage from "../../../../components/alert-message";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,
		control,

		loading, //formState
		errors,
		isSubmitting,
		tipoDesconto,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		setLoading,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<form className="form" onSubmit={handleSubmit(handleOnSubmit)}>
					<main className="overflow-auto">
						<div className="row">
							<TextInput
								label="Descrição da Promoção"
								id="descricao"
								register={register}
								errors={errors}
								required={true}
								className="col-12 col-md-8"
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
							/>

							<div className={`check-box-top col-12 col-md-4 flex items-center h-full`}>
								<div className="check-input mt-4">
									<input id="status_promocao" type="checkbox" {...register("status")} />
									<label htmlFor="status_promocao" className="mb-0">
										<span className="text-sm">Ativar Promoção</span>
									</label>
								</div>
							</div>

							<TextInput
								label="Data Início"
								id="inicio"
								type="date"
								register={register}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<TextInput
								label="Data Término"
								id="fim"
								type="date"
								register={register}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<TextInput
								label="Código do Cupom"
								id="cod_cupom"
								register={register}
								errors={errors}
								required={true}
								placeholder="Ex: NATAL2024 (Sem espaços)"
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<TextInput
								label="Valor Mínimo Compra (R$)"
								id="valor_minimo"
								type="number"
								step="0.01"
								register={register}
								errors={errors}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<SelectInput
								label="Tipo de Desconto"
								id="tipo_desconto"
								labelSelect="descricao"
								data={[
									{ tipo_desconto: "PERCENTUAL", descricao: "Percentual (%)" },
									{ tipo_desconto: "VALOR", descricao: "Valor Fixo (R$)" },
								]}
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-4"
								onKeyDown={libForm.EnterTab}
							/>

							{tipoDesconto === "PERCENTUAL" ? (
								<TextInput
									label="Desconto (%)"
									id="perc_desconto"
									type="number"
									step="0.01"
									register={register}
									errors={errors}
									className="col-12 col-md-4"
									onKeyDown={libForm.EnterTab}
								/>
							) : (
								<TextInput
									label="Desconto Fixo (R$)"
									id="valor_desconto"
									type="number"
									step="0.01"
									register={register}
									errors={errors}
									className="col-12 col-md-4"
									onKeyDown={libForm.EnterTab}
								/>
							)}

							{/* <div className={`check-box-top col-12 col-md-4 flex items-center h-full`}>
								<div className="check-input mt-4">
									<input
										id="todos_produtos"
										type="checkbox"
										{...register("todos_produtos")}
									/>
									<label htmlFor="todos_produtos" className="mb-0">
										<span className="text-sm">Todos os Produtos</span>
									</label>
								</div>
							</div> */}
						</div>

						<AlertMessage type="info" title="Regra de Aplicação">
							O desconto será aplicado apenas se o código do cupom for informado no checkout e as regras
							de data e valor mínimo forem atendidas.
						</AlertMessage>
					</main>

					<footer>
						<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>
				</form>
			)}
		</>
	);
};

export default Form;
